<app-userapi-shared-non-oauth [userApi]="userApi">

  @if (!userApi.privateKey) {
    <p [innerHTML]="userApi.api.configDescription"></p>

    <FloatingLabelInput
        id="publicKey"
        label="Rabo Smart Pay Contract ID"
        [appColor]="appColor()"
        [(myValue)]="userApi.publicKey"
        (myValueChange)="valueChanged()"
    ></FloatingLabelInput>

    <div class="md:mt-4">
      <div class="flex flex-row justify-center cursor-pointer my-3 text-gray-600 delay-300" (click)="togglePermissionGranted()">
        <i style="line-height: 1.35" class="far fa-{{ permissionGranted ? 'check-square' : 'square'}}"></i>
        <span class="text-xs ml-2" translate="INCLUDE_MODALUSERAPI_SINGLEKEY_RABOBANK_PERMISSION"></span>
      </div>
    </div>

    <div class="mt-6 text-sm" translate="INCLUDE_MODALUSERAPI_SINGLEKEY_RABOBANK_ONBOARDING"></div>
  } @else {
    <div class="my-6 text-sm" translate="INCLUDE_MODALUSERAPI_SINGLEKEY_RABOBANK_ONBOARDING_FINISHED"></div>
    <FloatingLabelInput
        id="privateKey"
        label="Rabo Smart Pay Client ID"
        [appColor]="appColor()"
        [readonly]="true"
        [(myValue)]="userApi.privateKey"
    ></FloatingLabelInput>
  }

</app-userapi-shared-non-oauth>